// export const baseUrl = 'https://api.hulluware.com'
export const baseUrl = 'https://api.hulluware.com'
// export const baseUrl = 'http://localhost:4001'
export const sellerBaseUrl = 'http://seller.hulluware.com'
export const TOKEN_KEY = 'hwtoken'

export const path = {
    getCategories: '/api/common/categories',
    myAccount: '/api/common/my-account',
    courses: '/api/courses',
    getCourseDetail: '/api/course',
    getVideoStream: '/api/administrator/get-video-stream',
    changeLanguage: '/api/common/set-lang',
    getLanguage: '/api/common/get-lang',
    fetchCourses: '/api/fetch-courses',
    searchCourses: '/api/common/search-courses',
    profile: '/api/profile',
    initializePayment: '/api/initialize-payment',
    verifyPayment: '/api/verify-payment',
    myCourses: '/api/my-courses',
    addToWishlist: '/api/add-to-wishlist',
    rateCourse: '/api/rate-course',
    wishlists: '/api/wishlists',
    stream: '/api/stream',
    instructor: '/api/get-instructor',
    getSectionMaterials: '/api/get-materials'
}
export const k = 'kTjNagFc1lXwCFdQQWq7aySUxBPO6rqTFLvGBPa4smU=';
export const i = 'G/I+23afErLNC41YVfoT5A==';